import { TranslatedText } from "@/components/common/text";

export const ProfilePreferenceRow = ({ label, children }) => {
    return (
        <div className="flex w-full items-center gap-4">
            <div className="shrink-0 text-sm font-medium text-cm-p-text-primary">
                <TranslatedText>{label}</TranslatedText>
            </div>
            {children}
        </div>
    );
};
